import { createSlice } from '@reduxjs/toolkit';

export enum MessageType {
  NORMAL = 'normal',
  WARNING = 'warning',
  LOCK = 'lock',
}

type InfoAuthenType = {
  email?: string;
  password?: string;
  isPreLogin?: boolean;
  type?: MessageType;
  messageError?: string;
  countWrong?: number;
  fullname?: string;
};

const initialState: InfoAuthenType = {
  email: '',
  password: '',
  isPreLogin: false,
  countWrong: 0,
};

const authenInfoSlice = createSlice({
  name: 'authenInfo',
  initialState,
  reducers: {
    setAuthenInfo: (_, action) => {
      return {
        ...initialState,
        email: action.payload?.email,
        password: action?.payload?.password,
        isPreLogin: action?.payload?.isPreLogin,
        type: action?.payload?.type,
        messageError: action?.payload?.messageError,
        countWrong: action?.payload?.countWrong,
        fullname: action?.payload?.fullname,
      };
    },
  },
});

export const { setAuthenInfo } = authenInfoSlice.actions;
export default authenInfoSlice;
